<script setup lang="ts">
import { ref } from "vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "" | "slide";
    dur?: number;
    perspective?: string;
  }>(),
  {
    type: "",
    dur: 500,
    perspective: "600px"
  }
);

const emits = defineEmits<{
  (event: "click", isFlipped: boolean): void;
}>();

const flip = ref(false);
const click = () => {
  flip.value = !flip.value;
  emits("click", flip.value);
};

defineExpose({});
</script>

<template>
  <div
    class="card-flip-scene"
    :style="{ perspective: props.perspective }"
  >
    <div
      class="card"
      :class="[props.type, { flip }]"
      :style="{
        transition: `transform ${props.dur}ms`
      }"
      @click="click"
    >
      <div class="face front"><slot name="front">front</slot></div>
      <div class="face back"><slot name="back">back</slot></div>
    </div>
  </div>
</template>

<!--
  ce 中不要使用v-bind
  border: 1px solid v-bind(borderColor);
-->
<style scoped>
.card-flip-scene {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.card {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
}
.card.slide {
  transform-origin: center right;
}
.card.flip {
  transform: rotateY(180deg);
}
.card.slide.flip {
  transform: translateX(-100%) rotateY(-180deg);
}
.face {
  position: absolute;
  height: 100%;
  width: 100%;
  backface-visibility: hidden;
}
.face > :nth-child(1) {
  display: block;
  width: 100%;
  height: 100%;
}
.back {
  transform: rotateY(180deg);
}
</style>
